import * as React from 'react';

import styles from './AboutPage.scss';
import Header from '../Header/Header';
import Cta from '../Cta/Cta';
import LinkButton from '../Button/LinkButton';
import PeopleSection from '../../containers/AboutPage/PeopleSection/PeopleSection';
import { AboutPageLocale } from './aboutPage.locale';
import headerBg from './headerBg.svg';

interface AboutPageProps {
  locale: AboutPageLocale;
}

const AboutPage: React.SFC<AboutPageProps> = ({ locale }) => (
  <>
    <Header
      title={locale.header.title}
      backgroundImage={headerBg}
      backgroundPosition="40% 410%"
      backgroundSize="auto 110%"
    >
      <div className="row mt-7 mt-md-8">
        {locale.header.sections.map((section, index) => (
          <div key={index} className="col-12 col-md-5 mb-4 mx-auto text-white">
            <div className={styles.headerDelimiter}>
              <span className={styles.headerDot} />
            </div>
            <h3 className="my-4 my-md-5 text-white">{section.title}</h3>
            <p className={styles.headerText}>{section.description}</p>
          </div>
        ))}
      </div>
    </Header>
    <main>
      <div className="container py-7 py-lg-8 text-center">
        <h2 className="mb-4 mb-md-5">{locale.title}</h2>
        <p className={styles.subtitle}>{locale.subtitle}</p>
        <div className="pb-4 pb-lg-5">
          <PeopleSection locale={locale.people} />
        </div>
      </div>
      <Cta title={locale.cta.title} subtitle={locale.cta.subtitle} backgroundType="logo">
        <div className="row justify-content-center">
          <div className="col-auto mb-3 mb-sm-0">
            <LinkButton to={locale.cta.primaryButton.href}>
              {locale.cta.primaryButton.text}
            </LinkButton>
          </div>
          <div className="col-auto">
            <LinkButton to={locale.cta.secondaryButton.href} secondary download>
              {locale.cta.secondaryButton.text}
            </LinkButton>
          </div>
        </div>
      </Cta>
    </main>
  </>
);

export default AboutPage;



// WEBPACK FOOTER //
// /www/client/src/components/AboutPage/AboutPage.tsx